import React from 'react';
import { useQuery } from '@apollo/client';
import TrackerMealQuery from './FetchMealQuery';

type result = {
  loading: boolean;
  trackerMealData?: any;
};

interface ITrackerMealConnectorApolloProps {
  children: (result: result) => React.ReactElement;
  mealId: number;
}

export const TrackerMealConnectorApollo: React.FC<ITrackerMealConnectorApolloProps> = ({
  children,
  mealId,
}) => {
  const { loading, data, error } = useQuery(TrackerMealQuery, {
    variables: {
      id: mealId,
    },
  });

  const result: result = {
    loading,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.trackerMealData = data.dailyTracker.meal;
  }

  return children(result);
};

export default TrackerMealConnectorApollo;
